import { render } from "./AddServiceModel.vue?vue&type=template&id=fa9e0cf8&scoped=true"
import script from "./AddServiceModel.vue?vue&type=script&lang=js"
export * from "./AddServiceModel.vue?vue&type=script&lang=js"

import "./AddServiceModel.vue?vue&type=style&index=0&id=fa9e0cf8&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9e0cf8"]])

export default __exports__